import { defineNuxtPlugin } from "nuxt/app"

import type { RouteLocationNormalized } from "#vue-router"

export default defineNuxtPlugin({
  name: "intercom",
  parallel: true,
  setup() {
    const { user } = useUser()
    const { currentRoute } = useRouter()
    const { initIntercom, isIntercomVisible, hideIntercom } = useIntercom()

    /** Handles the display of Intercom widget based on route metadata */
    function handleIntercomDisplay(route: RouteLocationNormalized) {
      if (route.meta?.layoutProps?.hideIntercom) {
        return hideIntercom()
      } else if (!isIntercomVisible.value) {
        initIntercom(user.value)
      }

      const { paddedIntercomIcon = undefined } = route.meta?.layoutProps || {}
      document.body.classList.toggle("intercom-icon-padded", Boolean(paddedIntercomIcon))

      if (isNumeric(paddedIntercomIcon)) {
        document.body.style.setProperty("--intercom-launcher-bottom", `${paddedIntercomIcon}px`)
      } else {
        document.body.style.removeProperty("--intercom-launcher-bottom")
      }
    }

    watch(currentRoute, handleIntercomDisplay, { immediate: true, deep: true })
  },
})
